import { Component, OnInit, OnDestroy, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { WebSocketHealthService } from "./core/connection/services/websocket-health.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit, OnDestroy {
  private webSocketHealth = inject(WebSocketHealthService);

  ngOnInit(): void {
    // 🚀 Inicializar sistema de health check do WebSocket
    this.webSocketHealth.initialize();
  }

  ngOnDestroy(): void {
    // 🛑 Limpar recursos ao destruir app
    this.webSocketHealth.destroy();
  }
}
